import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  organization: {},
  orgStructure: {},
  account: undefined,
  isFetchingOrg: false,
  hasFetchedOrg: false,
  hasCreatedOrg: false,
  isUpdatingOrg: false,
  hasUpdatedOrg: false,
  error: null,
};

export default reducerFactory(initialState, {
  [types.GET_ACCOUNT_REQUEST]: state => ({
    ...state,
    isFetchingOrg: true,
    hasFetchedOrg: false,
    error: null,
  }),
  [types.GET_ACCOUNT_SUCCESS]: (state, { response }) => ({
    ...state,
    isFetchingOrg: false,
    hasFetchedOrg: true,
    account: { ...response.org },
  }),
  [types.GET_ACCOUNT_FAILURE]: (state, { response }) => ({
    ...state,
    isFetchingOrg: false,
    hasFetchedOrg: false,
    error: response.error,
  }),
  [types.UPDATE_ACCOUNT_REQUEST]: state => ({
    ...state,
    isUpdatingOrg: true,
    hasUpdatedOrg: false,
    error: null,
  }),
  [types.UPDATE_ACCOUNT_SUCCESS]: (state, { response }) => ({
    ...state,
    isUpdatingOrg: false,
    hasUpdatedOrg: true,
    account: { ...response.org },
  }),
  [types.UPDATE_ACCOUNT_FAILURE]: (state, { response }) => ({
    ...state,
    isUpdatingOrg: false,
    hasUpdatedOrg: false,
    error: response.error,
  }),
  [types.ORG_STR_LIST_REQUEST]: state => ({
    ...state,
    isFetchingOrg: true,
    hasFetchedOrg: false,
  }),
  [types.ORG_STR_LIST_SUCCESS]: (state, { response }) => ({
    ...state,
    orgStructure: response,
    isFetchingOrg: false,
    hasFetchedOrg: true,
  }),
  [types.ORG_STR_LIST_FAILURE]: (state, { response }) => ({
    ...state,
    isFetchingOrg: false,
    error: response.error,
  }),
});
